export default __webpack_public_path__ + "static/media/Nitroxgallery_15.fb810c34.jpg";